import { Component, TemplateRef, OnInit } from "@angular/core";
import { Http, Headers, RequestOptions, Response } from "@angular/http";
import { URLSearchParams } from "@angular/http";
import { Router } from "@angular/router";
import { ApiService } from "../../_services/api.service";
import { AuthenticationService } from "../../_services/index";
import { PlatformLocation } from "@angular/common";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { SurveyService } from "../../_services/survey.service";

@Component({
  selector: "app-header-public",
  templateUrl: "./app-header-public.component.html",
  styleUrls: ["../../../assets/public_style.css"]
})
export class AppHeaderPublicComponent {
  public user_status: string;
  public locationHash: string;
  registermodalRef: BsModalRef;
  registerForm: FormGroup;
  showRegisterBox = 0;
  userStatus = "";
  constructor(
    private http: Http,
    private apiService: ApiService,
    private router: Router,
    private authenticationService: AuthenticationService,
    platformLocation: PlatformLocation,
    private fb: FormBuilder,
    private modalService: BsModalService,
    private surveyService: SurveyService,
    private toastr: ToastrService
  ) {
    this.locationHash = (platformLocation as any).location.hash;
  }
  userdata = [];
  ngOnInit(): void {
    this.user_status = this.authenticationService.user_status;

    this.apiService.http_get("/admin").subscribe(result => {
      this.userdata = result.json()[0];
    });
  }

  toggleBodyClass() {
    $("body").toggleClass("menuopen");
  }

  logout(): void {
    // clear token remove user from local storage to log user out
    localStorage.clear();
    this.router.navigateByUrl("/login");
  }

  openModal(template: TemplateRef<any>, classes) {
    this.registerForm = this.fb.group({
      firstname: [null, Validators.required],
      lastname: [null, Validators.required],
      username: [null, [Validators.required], this.isUsernameUnique.bind(this)],
      email: [
        null,
        [Validators.required, Validators.email],
        this.isEmailUnique.bind(this)
      ],
      password: [null, Validators.required],
      confirmpassword: [null, Validators.required],
      county: [],
      zip: [],
      county_id: []
    });

    this.registermodalRef = this.modalService.show(template, {
      class: classes
    });
  }

  isEmailUnique(control: FormControl) {
    const q = new Promise((resolve, reject) => {
      setTimeout(() => {
        this.authenticationService
          .isEmailRegisterd(control.value)
          .subscribe(data => {
            if (data) {
              resolve({ isEmailUnique: true });
            } else {
              resolve(null);
            }
          });
      }, 1000);
    });
    return q;
  }

  isUsernameUnique(control: FormControl) {
    const q = new Promise((resolve, reject) => {
      setTimeout(() => {
        this.authenticationService
          .isUsernameRegisterd(control.value)
          .subscribe(data => {
            if (data) {
              resolve({ isUsernameUnique: true });
            } else {
              resolve(null);
            }
          });
      }, 1000);
    });
    return q;
  }

  registerGuest(form) {
    this.surveyService
      .registerGuest(this.registerForm.value)
      .subscribe(result => {
        let response = result.json();

        if (response.status === true) {
          let currentUser = JSON.parse(localStorage.getItem("currentUser"));
          currentUser.email = response.data.email;
          currentUser.status = response.data.user_status;
          currentUser.county = response.data.county;
          currentUser.zip = response.data.zipcode;
          localStorage.setItem("currentUser", JSON.stringify(currentUser));

          this.registermodalRef.hide();
          this.showRegisterBox = 0;
          this.userStatus = response.data.user_status;
          this.toastr.success(
            "Registration has been completed successfully",
            "Success"
          );

          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          this.toastr.error("Your attempt has been failed", "Error", {
            timeOut: 3000
          });
        }
      });
    //}
  }
}

/* This is the Modal Component */
@Component({
  selector: "child-modal",
  templateUrl: "../../views/survey/survey-modal.component.html"
})
export class ChildModalComponent implements OnInit {
  form: FormGroup;
  counties: any = [];
  zipcodes: any = [];
  county: any;
  zip: any;

  constructor(
    public bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private authenticationService: AuthenticationService,
    private surveyService: SurveyService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    var currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.county = currentUser && currentUser.county ? currentUser.county : null;
    this.zip = currentUser && currentUser.zip ? currentUser.zip : null;
    if (this.zip) {
      this.zip = this.zip.toString();
    }
    if (this.county) {
      this.getZipCodes(this.county, 0);
    }

    this.form = this.fb.group({
      county: [this.county, Validators.required],
      zip: [this.zip, Validators.required],
      county_id: []
    });

    let post = {
      add: "GetCounties",
      call: "GetCounties.Get_Counties",
      data: { state: "oklahoma" }
    };
    this.authenticationService.referWebInfo(post).subscribe(result => {
      this.counties = result;
    });
  }

  getZipCodes(county, flag) {
    if (flag && flag == 1) {
      this.form.patchValue({ zip: null });
    }
    let post = {
      add: "GetZips",
      call: "GetZips.Get_Zips",
      data: { state: "oklahoma", county: county }
    };
    this.authenticationService.referWebInfo(post).subscribe(result => {
      this.zipcodes = result;
    });
  }

  save() {
    let countyObj = this.counties.filter(
      item =>
        item.County.toLowerCase().indexOf(
          this.form.controls.county.value.toLowerCase()
        ) !== -1
    );

    if (countyObj.length > 0) {
      this.form.patchValue({ county_id: countyObj[0]["County_Code"] });

      this.surveyService.saveCounty(this.form.value).subscribe(data => {
        if (data.json() > 0) {
          var currentUser = JSON.parse(localStorage.getItem("currentUser"));
          currentUser.county = this.form.controls.county.value;
          currentUser.zip = this.form.controls.zip.value;
          localStorage.setItem("currentUser", JSON.stringify(currentUser));
          this.toastr.success(
            "Your county & zipcode has been successfully saved!",
            "Success"
          );
        } else {
          this.toastr.error("Everything is broken", "Error", {
            timeOut: 3000
          });
        }
        this.bsModalRef.hide();
      });
    }
  }
}



// WEBPACK FOOTER //
// /var/www/html/LASO/laso-client/src/app/components/app-header-public/app-header-public.component.ts